require('./cardActivatorForm.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
// @ constants
const { CARD_ACTIVATION_ID } = require('constants/operationTypes');
const { CARD_ACTIVATION_ID_CC } = require('constants/contactCenter/operationTypes');
const { recordProcess, PROC_ACTIVATE_CARD, PROC_START } = require('utilities/tagging');
const { CARD_ECARD } = require('constants/index');


class CardActivatorForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    componentDidMount() {
        recordProcess(PROC_ACTIVATE_CARD, PROC_START);
    }

    handleOnClick() {
        const { immCard, activateCard } = this.props;

        activateCard(immCard.get('cardId'));
    }

    render() {
        const { immCardActivation, immCard } = this.props;
        const loadingAnimation = immCardActivation.get('isFetching');

        const operationParams = {
            pan: nonNumericFilter(immCard.get('number'))
        };
        const isOpenYoung = immCard.get('isOpenYoung');
        const isVirtualCredit = immCard.get('isVirtualCredit');
        const isVirtualDebit = immCard.get('isVirtualDebit');
        const type = immCard.get('type');
        const operative = formatText('operatives-cardActivate');

        let errorMessage, warningMessage;

        if (immCardActivation.get('sent') && !immCardActivation.get('success')) {
            const messageKey = immCardActivation.get('message');

            errorMessage = (
                <div className="card-activator-form__error">
                    <FormattedText value={messageKey} />
                </div>
            );
        }
        
        if (isOpenYoung || (!isVirtualCredit && !isVirtualDebit && type !== CARD_ECARD)) {
            warningMessage = (
                <div className="card-activator-form__warning-message">
                    <OKMessage type="important" >
                        <FormattedText value="cardActivate-warningMessage" />
                    </OKMessage>
                </div>
            );
        }

        return (
            <OKSectionBox className="card-activator-form">
                <header className="card-activator-form__header">
                    <FormattedText value="cardActivate-securityConfirmation" />
                </header>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                {warningMessage}
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                <section className="card-activator-form__content">
                    <FormattedText value="cardActivate-informativeText" />
                </section>
                <section className="card-activator-form__signature-passcode">
                    <SignaturePattern
                        operationType={__CONTACT_CENTER__ ? CARD_ACTIVATION_ID_CC : CARD_ACTIVATION_ID}
                        operationParams={operationParams}
                    />
                    {errorMessage}
                </section>

                <footer className="card-activator-form__footer">
                    <div className="pull-left">
                        <OKLink
                            modifier="inherit-styles"
                            to={'/myprofile/cards'}
                        >
                            <FormattedText value={`cardActivate-cancel`} />
                        </OKLink>
                    </div>
                    <SignaturePatternButton onClick={this.handleOnClick} loading={loadingAnimation}>
                        <FormattedText value="cards-activate" />
                    </SignaturePatternButton>
                </footer>
            </OKSectionBox>
        );
    }
}

CardActivatorForm.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardActivation: PropTypes.object.isRequired,
    activateCard: PropTypes.func.isRequired
};

module.exports = CardActivatorForm;
